import { GID } from '@unlikelystudio/commerce-connector'
import { ProductCardProps } from '~/components/UI/ProductCard'
import serializeProductCard from '~/data/serialize-product-card'
import getByUuid from '~/lib/storyblok/get-by-uuid'
import { FetchListWithContentsPayload } from '~/lib/swym/wishlist/types'
import { addGIDPrefix, isGID } from '~/utils/shopify-ids'

export type TProductFields = FetchListWithContentsPayload["list"]["listcontents"]

export type WishlistProduct = {
  product: ProductCardProps
  wishlistProductId: string
  variantId: GID
  tags: string[]
}

export async function fetchWishlistProducts({
  productFields,
  locale,
}: {
  productFields: TProductFields
  locale?: string
}): Promise<WishlistProduct[] | null> {
  try {
    if (!productFields || !productFields?.length) return []
    const products = await Promise.all(
      productFields.map(async (productField) => await serializeWishlistProductCard({ productField, locale }))
    )

    return products.filter(Boolean)
  } catch (err) {
    console.error("Error fetching wishlist products", err)
    return null
  }
}

export async function serializeWishlistProductCard({
  productField,
  locale,
}: {
  productField: Partial<FetchListWithContentsPayload["list"]["listcontents"][number]>
  locale?: string
  countryCode?: string
}): Promise<WishlistProduct | null> {
  const productId = addGIDPrefix("Product", productField?.empi)
  const variantId = addGIDPrefix("ProductVariant", productField?.epi)
  const uuid = productField?.cprops?.uuid


  if (!isGID("Product", productId) && !isGID("ProductVariant", variantId) && !uuid) {
    return null
  }

  const fetchedProduct = await getByUuid(uuid)


  if (!fetchedProduct) {
    return null
  }

  const serializedProduct = await serializeProductCard(fetchedProduct, locale, true)

  if (!serializedProduct) {
    return null
  }

  return {
    product: serializedProduct,
    wishlistProductId: productField?.id,
    variantId,
    tags: [],
  }
}
